import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import { H1 } from '../../../components/typography'

export const HeadLine = styled.h1`
  font-size: 48px;
  font-weight: 400;
  color: inherit;
  margin: 60px 0 30px 0;
  ${media.max.md`
    font-size: 26px;
    margin: 60px 0 14px 0;
  `}
`

export const SubText = styled.p`
  text-align: center;
  max-width: 700px;
  font-size: 16px;
  margin: 0;
  ${media.max.md`
    font-size: 13px;
    max-width: 310px;
  `}
`

export const SubParagraph = styled.p`
  text-align: center;
  max-width: 1011px;
  font-size: 14px;
  line-height: 24px;
  margin: 10px 0 0 0;
  ${media.max.md`
    font-size: 8px;
    line-height: 16px;
    margin: 0;
    max-width: 84vw;
  `}
`

export const PhoneComboWrapper = styled.div``

export const Banner = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  ${PhoneComboWrapper} {
    margin-top: 70px;
  }
  ${media.max.md`
    padding: 0 0.3rem;
    ${PhoneComboWrapper} {
      margin-top: 0.4rem;
    }
    > h1{
      margin: 0.3em 0;
    }
  `}
`
export const PrimaryText = styled.p`
  color: ${p => p.theme.color.textPrimary};
  font-size: 16px;
  text-align: center;
  ${media.max.md`
    text-align: left;
    font-size: 10px;
    padding: 0;
  `}
`
export const SecondaryText = styled.p`
  color: ${p => p.theme.color.textSecondary};
  font-size: 14px;
  text-align: left;
  ${media.max.md`
    font-size: 13px;
  `}
`
export const SectionTitle = styled(H1)`
  color: ${p => p.theme.color.textTitle};
  margin: 60px auto;
  text-align: center;
  font-weight: 400;
  ${media.max.md`
    margin: 18px auto;
  `}
`
export const SubmitBtn = styled.button`
  margin-top: 40px;
  width: 174px;
  height: 48px;
  background: #01ab5d;
  border-radius: 24px;
  border: 0;
  outline: 0;
  cursor: pointer;
  color: #ffffff;
  ${media.max.md`
    width: 28.6vw;
    height: 8.47vw;
    margin: 10px auto;
  `}
`
